<template>
    <div class="payment-options-container">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-12">
                <a v-if="invoice.contact && invoice.status === 'invoiced'" :href="'/invoice/download/'+invoice.id+'/pdf'" class="btn btn-primary btn-bigger-font pull-right"><i class="fa fa-download"></i>Download invoice</a>
                <a v-if="invoice.contact && invoice.status === 'paid'" :href="'/invoice/download/'+invoice.id+'/pdf'" class="btn btn-primary btn-bigger-font pull-right"><i class="fa fa-download"></i>Download receipt</a>
            </div>
        </div>
        <div class="row pt-4" v-show="activeCC || activeEmail">
            <div class="col-8 offset-2">
                <div class="card">
                    <div class="card-body">
                        <div class="payment-form-wrapper CC" v-show="activeCC">
                            <i class="close-icon pull-right" @click="showCC"></i>
                            <h2>Pay with a credit card</h2>
                            <form method="POST" :action="'/invoice/'+invoice.id+'/payment'" id="creditCardForm" class="submit-once" @submit="checkCCForm">

                                <div v-if="errors.length">
                                    <p>
                                        <b>Please correct the following error(s):</b>
                                    <ul>
                                        <li v-for="error in errors">{{ error }}</li>
                                    </ul>
                                    </p>
                                </div>

                                <div class="form-group clear-pull">
                                    <label for="cardName">Cardholder Name <em class="yellow no-style">*</em></label>
                                    <input type="text" name="cardName" id="cardName" class="form-control"
                                           v-model="cardName" data-ref="cardName"  required="required">
                                </div>

                                <div class="form-group">
                                    <div class="field">
                                        <label for="card-number">Card number <em class="yellow no-style">*</em></label>
                                        <div id="card-number" ref="cardNumber" class="input empty"></div>
                                        <div class="baseline"></div>
                                    </div>
                                </div>
                                <div class="form-group form-50">
                                    <label for="card-expiry" >Expiry <em class="yellow no-style">*</em></label>
                                    <div id="card-expiry" ref="cardExpiry" class="input empty"></div>
                                    <div class="baseline"></div>
                                </div>
                                <div class="form-group form-50">
                                    <label for="card-cvc">CVC <em class="yellow no-style">*</em></label>
                                    <div id="card-cvc" ref="cardCvc" class="input empty"></div>
                                    <div class="baseline"></div>
                                </div>

                                <div id="card-errors" role="alert"></div>

                                <div class="form-group" style="display:none;">

                                    <div id="card-element" ref="card">
                                        <!-- A Stripe Element will be inserted here. -->
                                    </div>

                                    <!-- Used to display Element errors. -->

                                </div>



                                <div class="form-group">
                                    <label for="companyCC">Company Name</label>
                                    <input type="text" name="company" id="companyCC" class="form-control"
                                           v-model="company">
                                </div>

                                <div class="form-group form-50">
                                    <label for="address">Billing Address <em class="yellow no-style">*</em></label>
                                    <input type="text" name="address" id="address" class="form-control"
                                            required v-model="address">
                                </div>

                                <div class="form-group form-50">
                                    <label for="city">City <em class="yellow no-style">*</em></label>
                                    <input type="text" name="city" id="city" class="form-control"
                                            required="required" v-model="city">
                                </div>



                                <div class="form-group form-50">
                                    <label for="state">State/Province:</label>
                                    <region-select v-model="state" :country="country" :region="state" name="state" id="state" />
                                </div>

                                <div class="form-group form-50">
                                    <label for="zip">Zip/Postal Code: <em class="yellow no-style">*</em></label>
                                    <input type="text"   maxlength="15" name="zip" id="zip" class="form-control"
                                           required="required" v-model="zip">
                                </div>

                                <div class="form-group form-50">
                                    <label for="country">Country (if other than USA):</label>
                                    <country-select v-model="country" :country="country" topCountry="US" name="country" id="country" />
                                </div>


                                <div class="form-100"></div>
                                <div class="form-group form-50"></div>
                                <div class="form-group ">
                                    <input  type="hidden" v-model="csrf" name="_token" />
                                    <button :disabled="isLoading" type="submit" name="payment_type" value="credit_card" class="btn btn-primary btn-bigger-font btn-validate-checker btn-font-19">
                                        <circle_check></circle_check>
                                        <span>Confirm and pay with this card</span></button>
                                </div>
                            </form>
                        </div>


                        <div class="payment-form-wrapper" v-show="activeEmail">
                            <i class="close-icon pull-right" @click="showEmail"></i>
                            <h2>Email billing contact</h2>
                            <form method="POST" :action="'/invoice/'+invoice.id+'/payment'" id="invoiceForm" class="submit-once" @submit="sendInvoiceInfo">

                                <div v-if="errors.length">
                                    <p>
                                        <b>Please correct the following error(s):</b>
                                    <ul>
                                        <li v-for="error in errors">{{ error }}</li>
                                    </ul>
                                    </p>
                                </div>
                                <div class="form-group clear-pull">
                                    <label for="cardName">Billing Contact Name <em class="yellow no-style">*</em></label>
                                    <input type="text" name="cardName" id="cardName2" class="form-control"
                                           v-model="cardName" data-ref="cardName" required="required">
                                </div>

                                <div class="form-group clear-pull">
                                    <label for="company">Billing Company</label>
                                    <input type="text" name="company" id="company" class="form-control"
                                           v-model="company" data-ref="company">
                                </div>

                                <div class="form-group form-50">
                                    <label for="address">Billing Address <em class="yellow no-style">*</em></label>
                                    <input type="text" name="address" id="address2" class="form-control"
                                            required v-model="address">
                                </div>

                                <div class="form-group form-50">
                                    <label for="city">City <em class="yellow no-style">*</em></label>
                                    <input type="text" name="city" id="city2" class="form-control"
                                           required="required" v-model="city">
                                </div>



                                <div class="form-group form-50">
                                    <label for="state">State/Province:</label>
                                    <region-select v-model="state" :country="country" :region="state" name="state" />
                                </div>

                                <div class="form-group form-50">
                                    <label for="zip">Zip/Postal Code: <em class="yellow no-style">*</em></label>
                                    <input type="text"   maxlength="15" name="zip" id="zip2" class="form-control"
                                            required="required" v-model="zip">
                                </div>

                                <div class="form-group form-50">
                                    <label for="country">Country (if other than USA):</label>
                                    <country-select v-model="country" :country="country" topCountry="US" name="country" />
                                </div>

                                <div class="form-group form-50">
                                    <label for="po_number">PO Number: </label>
                                    <input type="text"   maxlength="20" name="po_number" id="po_number" class="form-control"
                                           v-model="po_number">
                                </div>

                                <div class="form-group-beside">
                                    <label for="recipients">Enter the email address you want the invoice sent to: <em class="yellow no-style">*</em></label>
                                    <input type="email" name="recipients" id="recipients" class="form-control"
                                           v-model="recipients" required="required">
                                </div>

                                <div class="form-group pull-right email-submit">
                                    <input  type="hidden" v-model="csrf" name="_token" />
                                    <button type="submit" name="payment_type" value="invoice" class="btn btn-primary btn-bigger-font">
                                        <circle_check></circle_check>
                                        <span>Send invoice</span></button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="payByWrapper row pt-4">

            <div class="col-lg-12 col-xl-6 pay-wrapper cc-wrapper " v-if="invoice.amount_due > 0">
                <button class="cc-image " :class="greyCC" @click="showCC" ></button>
            </div>

            <div class="col-lg-12 col-xl-6 pay-wrapper email-wrapper mt-2 mt-xl-0 " v-if="invoice.status !== 'paid'">
                <button class="email-image " :class="greyEmail" @click="showEmail" ></button>
            </div>

        </div>


        <modal v-if="errorModal" @close="reload">
            <h3 slot="header">Error</h3>
            <div class="content" slot="body">
                {{ errorMessage }}
                <p>Please try again or contact the Television Academy at <a href="mailto:honors@televisionacademy.com" target="_blank">honors@televisionacademy.com</a>.</p>
            </div>
            <div class="form-group-submit" slot="footer">
                <button class="pull-left" @click="reload">Close</button>
            </div>
        </modal>

    </div>
</template>

<script>

import Circle_check from "../Icons/circle_check.vue";

let stripe = Stripe(stripeKey);
let elements = stripe.elements();
let cardNumber = undefined;
let cardCvc = undefined;
let cardExpiry = undefined;
let elementStyles = {
    iconStyle: "solid",
    base: {

        iconColor: '#737373',
        color: '#737373',
        fontWeight: 500,
        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
        fontSize: '16px',
        border: '1px solid red',
        fontSmoothing: 'antialiased',
        ':-webkit-autofill': {
            color: '#fce883',
        },
        '::placeholder': {
            color: '#CFD7DF',
        },
    },
    invalid: {
        // All of the error styles go inside of here.
        iconColor: '#ff0000',
        color: '#ff0000',

    }

};

    // Import component
    import loading from 'vue-loading-overlay';
    import modal from '../components/Modal.vue';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        props: ['invoice'],
        components: {
            Circle_check,
            loading,
            modal
        },
        data() {
            return {
                errorMessage: '',
                errorModal: false,
                hasCardErrors: false,
                isLoading: false,
                fullPage: true,
                csrf:window.Laravel.csrfToken,
                greyCC: '',
                greyEmail: '',
                activeEmail: false,
                activeCC: false,
                errors: [],
                totalCost: 0,
                token: '',
                orderCosts: [],
                recipients: '',
                po_number: '',
                cardName: "",
                company: '',
                country: 'US',
                state: '',
                zip:'',
                city:'',
                address: ''
            }
        },
        mounted() {
            var elementClasses = {
                focus: 'focused',
                empty: 'empty',
                invalid: 'invalid',
            };

            cardNumber = elements.create('cardNumber', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardNumber.mount(this.$refs.cardNumber);

            cardExpiry = elements.create('cardExpiry', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardExpiry.mount(this.$refs.cardExpiry);

            cardCvc = elements.create('cardCvc', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardCvc.mount(this.$refs.cardCvc);

            /*card = elements.create('card', {style: elementStyles});
            card.mount(this.$refs.card);*/

            if(this.invoice.contact) {
                //console.log(this.invoice.contact.name);
                // this.invoice.contact = JSON.parse(this.invoice.contact);

                this.cardName = this.invoice.contact.name;
                this.company = this.invoice.contact.company;
                this.address = this.invoice.contact.address;
                this.city = this.invoice.contact.city;
                this.state = this.invoice.contact.state;
                this.zip = this.invoice.contact.zip;
                this.country = this.invoice.contact.country;
            }
            if (this.invoice.email) {
                this.recipients = this.invoice.email;
            }
            if (this.invoice.po_number) {
                this.po_number = this.invoice.po_number;
            }
        },
        methods: {
            reload: function() {
                this.errorModal = false;
            },
            showEmail: function() {
                if (this.activeEmail) {
                    this.greyCC = '';
                } else {
                    this.greyCC = 'disable';
                    this.greyEmail = '';
                }
                this.activeCC = false;
                this.activeEmail = !this.activeEmail;
            },
            showCC: function() {
                if (this.activeCC) {
                    this.greyEmail = '';
                } else {
                    this.greyCC = '';
                    this.greyEmail = 'disable';
                }
                this.activeEmail = false;
                this.activeCC = !this.activeCC;
            },
            checkCCForm: function(e) {
                let app = this;
                var additionalData = {
                    name: app.cardName ? app.cardName : undefined,
                    address_line1: app.address ? app.address : undefined,
                    address_city: app.city ? app.city : undefined,
                    address_state: app.state ? app.state : undefined,
                    address_zip: app.zip ? app.zip : undefined,
                };

                stripe.createToken(cardNumber, additionalData).then(function(result) {
                    let form = $('#creditCardForm');
                    if (result.error) {
                        app.hasCardErrors = true;
                        app.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                        app.isLoading = false;
                        return;
                    } else {
                        app.token = result['token']['id'];
                        app.sendCCInfo()
                    }
                }).catch((err) => {
                    console.log("error: "+err.message)
                    alert("There was an error processing your payment. Please try again.");
                    app.isLoading=false
                });

                e.preventDefault();
            },
            sendCCInfo: function() {
                let app = this;
                app.isLoading = true;
                let data = {
                    isajax : 'true',
                    stripeToken: app.token,
                    cardName: app.cardName,
                    company: app.company,
                    country: app.country,
                    state: app.state,
                    zip: app.zip,
                    city: app.city,
                    address: app.address,
                    payment_type: 'credit_card'
                };
                axios.post(`/invoice/${app.invoice.id}/payment`, data)
                    .then(res => {
                        //console.log('form submitted', res.data)
                        window.location.replace('/invoices?payment=creditcard');
                    }).catch(err => {
                        app.isLoading = false;
                        app.errorModal = true;
                        if (err.response.data.message && err.response.status == 400) {
                            app.errorMessage = err.response.data.message;
                        } else {
                            app.errorMessage = 'There was an error processing your payment.'
                        }
                    });
            },

            sendInvoiceInfo: function(e) {
                let app = this;
                app.isLoading = true;
                let data = {
                    isajax : 'true',
                    cardName: app.cardName,
                    company: app.company,
                    country: app.country,
                    state: app.state,
                    zip: app.zip,
                    city: app.city,
                    address: app.address,
                    recipients: app.recipients,
                    po_number: app.po_number,
                    payment_type: 'invoice'
                };
                axios.post('/invoice/'+app.invoice.id+'/payment', data)
                    .then(res => {
                        //console.log('form submitted', res.data)
                        window.location.replace('/invoices');
                    }).catch(err => {
                        //console.log(err.response.data.message);
                        app.isLoading = false;
                        app.errorModal = true;
                    if (err.response.data.message) {
                        app.errorMessage = "There was a problem sending your invoice. " + err.response.data.message;
                    } else {
                        app.errorMessage = "There was a problem sending your invoice. Please try again.";
                    }
                    });
                e.preventDefault();
            }
        },

    }
</script>

<style>
.StripeElement {
    width: 100%;
    display: block;
    height: calc(1.6em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-top: 0;
    border-right: 0;
    border-radius: 0;
    box-shadow: none;
    width: 100%;
}

</style>
